/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { UploadCloud, FileSearch, BadgePercent, CreditCard, Timer, MailOpen, Smile, MessageSquare, CheckCircle, ShieldCheck, Star, Edit3, Users, MonitorSmartphone, MicVocal, FileText } from 'lucide-react';
import './HowItWorksPage.css';

const ProcessStep = ({ stepNumber, icon: Icon, title, description, isVisible }) => (
    <div className={`process-step animate-on-scroll ${isVisible ? 'is-visible' : ''}`}>
        <div className="step-header">
            <div className="step-icon-wrapper">
                <Icon size={32} strokeWidth={1.5} />
            </div>
            <span className="step-number">Krok {stepNumber}</span>
            <h3>{title}</h3>
        </div>
        <div className="step-description">
            <p>{description}</p>
        </div>
    </div>
);

function HowItWorksPage() {
    const [titleRef, isTitleVisible] = useIntersectionObserver();
    const [step1Ref, isStep1Visible] = useIntersectionObserver();
    const [step2Ref, isStep2Visible] = useIntersectionObserver();
    const [step3Ref, isStep3Visible] = useIntersectionObserver();
    const [step4Ref, isStep4Visible] = useIntersectionObserver();
    const [step5Ref, isStep5Visible] = useIntersectionObserver();
    const [step6Ref, isStep6Visible] = useIntersectionObserver();
    const [ctaRef, isCtaVisible] = useIntersectionObserver();

    return (
        <>
            <section ref={titleRef} className={`page-header-section section-bg-white animate-on-scroll ${isTitleVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>Jak Zamówić Tłumaczenie w Lingland?</h1>
                    <p className="subtitle">Nasz proces jest prosty, przejrzysty i zaprojektowany z myślą o Twojej wygodzie. Zobacz, jak łatwo możesz otrzymać profesjonalne tłumaczenie.</p>
                </div>
            </section>

            <section className="process-steps-section section-bg-light-gray">
                <div className="container">
                    <div className="process-steps-wrapper">
                        <div className="process-line"></div>

                        <div ref={step1Ref}>
                            <ProcessStep
                                stepNumber={1}
                                icon={UploadCloud}
                                title="Prześlij Pliki i Informacje"
                                description="Skorzystaj z naszego intuicyjnego formularza wyceny, aby przesłać swoje dokumenty. Podaj języki tłumaczenia, ewentualne uwagi i preferowany termin realizacji. Im więcej szczegółów, tym dokładniejsza wycena."
                                isVisible={isStep1Visible}
                            />
                        </div>
                        <div ref={step2Ref}>
                             <ProcessStep
                                stepNumber={2}
                                icon={FileSearch}
                                title="Analiza i Wycena"
                                description="Nasz zespół analizuje przesłane materiały pod kątem objętości, stopnia skomplikowania i specjalistycznej terminologii. W ciągu kilku godzin (a często szybciej!) otrzymasz e-mailem szczegółową, niezobowiązującą wycenę."
                                isVisible={isStep2Visible}
                            />
                        </div>
                       <div ref={step3Ref}>
                             <ProcessStep
                                stepNumber={3}
                                icon={BadgePercent}
                                title="Akceptacja Oferty"
                                description="Zapoznaj się z przygotowaną ofertą. Jeśli warunki Ci odpowiadają, po prostu potwierdź zlecenie, odpowiadając na e-mail lub klikając link akceptacyjny. Akceptacja oznacza rozpoczęcie procesu tłumaczenia."
                                isVisible={isStep3Visible}
                            />
                       </div>
                        <div ref={step4Ref}>
                            <ProcessStep
                                stepNumber={4}
                                icon={CreditCard}
                                title="Realizacja Tłumaczenia"
                                description="Doświadczony tłumacz, specjalizujący się w danej dziedzinie, przystępuje do pracy. W przypadku większych projektów nad całością czuwa dedykowany Project Manager, zapewniając spójność i terminowość."
                                isVisible={isStep4Visible}
                            />
                        </div>
                        <div ref={step5Ref}>
                            <ProcessStep
                                stepNumber={5}
                                icon={CheckCircle} // Poprawiony użyty import
                                title="Weryfikacja i Kontrola Jakości"
                                description="Gotowe tłumaczenie przechodzi proces weryfikacji (proofreading) przez drugiego lingwistę oraz kontrolę jakości QA, aby zapewnić najwyższy standard, poprawność i spójność tekstu."
                                isVisible={isStep5Visible}
                            />
                        </div>
                         <div ref={step6Ref}>
                             <ProcessStep
                                stepNumber={6}
                                icon={MailOpen}
                                title="Dostarczenie Gotowego Tłumaczenia"
                                description="Finalną wersję tłumaczenia otrzymasz drogą mailową w uzgodnionym formacie i terminie. Jesteśmy gotowi na ewentualne uwagi i pytania po dostarczeniu zlecenia."
                                isVisible={isStep6Visible}
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section ref={ctaRef} className={`cta-how-end section-bg-white animate-on-scroll ${isCtaVisible ? 'is-visible' : ''}`}>
                 <div className="container text-center">
                    <h2>Masz pytania dotyczące procesu?</h2>
                    <p className="subtitle">Nasz zespół chętnie wyjaśni każdy etap i pomoże wybrać najlepsze rozwiązanie.</p>
                     <Link to="/kontakt" className="button-secondary">
                         <MessageSquare size={18} style={{ marginRight: '0.5rem' }}/> Zapytaj eksperta
                     </Link>
                 </div>
            </section>
        </>
    );
}

export default HowItWorksPage;